var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.currentComponent)?_c(_vm.currentComponent,{ref:"createPageComponent",tag:"component"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }